import React from "react";
import { Box, Dialog, DialogTitle, DialogContent, Container } from "@mui/material";

const RecurrencePopup = (props) => {
    return (
        <Container id="rp_Container">
            <Dialog id="rp_Dialog" open={props.open} onClose={props.onClose} maxWidth="md">
                <DialogTitle id="rp_DialogTitle">{props.title}</DialogTitle>
                <Box sx={{ m: 1 }} />
                <DialogContent id="rp_DialogContent">{props.children}</DialogContent>
            </Dialog>
        </Container>
    );
};

export default RecurrencePopup;
